<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    {{ projectItem.projectName }}
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'
import OnEvent from '../common/OnEvent.vue'

export default {
  extends: OnEvent,
  props: {
    propValue: {
      type: String,
      required: true,
      default: ''
    },
    request: {
      type: Object,
      default: () => {}
    },
    element: {
      type: Object,
      default: () => {}
    },
    linkage: {
      type: Object,
      default: () => {}
    },
    noEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      canEdit: false,
      ctrlKey: 17,
      isCtrlDown: false,
      cancelRequest: null
    }
  },
  computed: {
    ...mapState({
      editMode: state => state.compose.editMode,
      curComponent: state => state.compose.curComponent,
      projectItem: state => state.user.projectItem
    })
  },
  created() {
    // 注意，修改时接口属性时不会发数据，在预览时才会发
    // 如果要在修改接口属性的同时发请求，需要 watch 一下 request 的属性
    if (this.request) {
      // 第二个参数是要修改数据的父对象，第三个参数是修改数据的 key，第四个数据修改数据的类型
      this.cancelRequest = request(this.request, this.element, 'propValue', 'string')
    }
  },
  beforeDestroy() {
    // 组件销毁时取消请求
    this.request && this.cancelRequest()
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>

</style>
